import React from 'react';
import FormInput from '../Form/FormInput';
import { Container, Row, Col } from 'reactstrap';

const CharterAdminDetail = (props) => {
    const { invite } = props;
   
  
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //<BooleanInput id='shared' label='Shared' />
    return <Container>
        <Row>
            <Col>
                <Row>
                    <Col>
                        <FormInput id='firstName' label='First Name' />
                    </Col>
                    <Col>
                        <FormInput id='lastName' label='Last Name' />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormInput id='companyName' label='Company Name' />
                    </Col>
                    <Col>
                        <FormInput id='companyAddress' label='Company Address' />
                    </Col>
                    <Col>
                        <FormInput id='companyPhone' label='Company Phone' />
                    </Col>
                </Row>
                <Row>

                    <Col>
                        <FormInput readOnly={!invite} id='email' label='Email' />
                    </Col>
                </Row>

            </Col>
        </Row>
    </Container>

};

export default CharterAdminDetail;




